module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_c('span', {
    staticClass: "btn btn-default fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true",
      "title": _vm.translations.lbl_clients
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }), _vm._v("\n                " + _vm._s(_vm.translations.lbl_client) + ": " + _vm._s(_vm.client.clientName) + "\n            ")])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: {
      active: _vm.isTabActive['tab1']
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setActiveTab('tab1')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.getTranslation('lbl_tab_dashboard')) + "\n            ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isTabActive['tab2']
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setActiveTab('tab2')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.getTranslation('lbl_tab_management')) + "\n            ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isTabActive['tab3']
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setActiveTab('tab3')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.getTranslation('menu_main_user_list')) + "\n            ")])]), _vm._v(" "), (_vm.client.useCustomers) ? _c('li', {
    class: {
      active: _vm.isTabActive['tab4']
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setActiveTab('tab4')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.getTranslation('menu_main_customer_list')) + "\n            ")])]) : _vm._e()]), _vm._v(" "), (_vm.isTabActive['tab4']) ? [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.customerDisplay) ? _c('customer-block', {
    attrs: {
      "client": _vm.client,
      "isClientSubPage": true
    }
  }) : _vm._e()], 1)])] : _vm._e(), _vm._v(" "), (_vm.isTabActive['tab3']) ? [_c('user-list', {
    attrs: {
      "client": _vm.client,
      "hideTitle": true,
      "isClientSubPage": true
    }
  })] : _vm._e(), _vm._v(" "), (_vm.isTabActive['tab2']) ? [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('client-edit-block', {
    attrs: {
      "hideTitle": true
    }
  })], 1)])])] : _vm._e(), _vm._v(" "), (_vm.isTabActive['tab1']) ? [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.timeplanDisplay) ? _c('timeplan-block', {
    attrs: {
      "client": _vm.client
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.contactsDisplay) ? _c('contacts-block', {
    attrs: {
      "client": _vm.client
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.ticketsDisplay) ? _c('tickets-block', {
    attrs: {
      "client": _vm.client
    }
  }) : _vm._e()], 1)])])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8314babc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App/protected/components/clients/Client.vue
// module id = 694
// module chunks = 0